import React from 'react';
//import ReactDOM from 'react-dom';
import './DrumApp.css';
import Drumpad from './Drumpad';

class DrumApp extends React.Component{
    constructor(props){
        super(props);
        this.state={
           drumPadId: ['Q','W','E','A','S','D','Z','X','C'],
           display: 'Heater-1',
           displayText:{
               'Q':'Heater-1',
               'W':'Heater-2',
               'E':'Heater-3',
               'A':'Dsc_Oh',
               'S':'Kick_n_Hat',
               'D':'Bld_H1',
               'Z':'Dry_Ohh',
               'X':'Brk_Snr',
               'C':'Punchy_kick'
           }
        }
        this.clickablePlay=this.clickablePlay.bind(this);
    }

  componentDidMount(){
      document.addEventListener("keypress",(event) => {
        const keyName = event.key;
        console.log(keyName.toUpperCase());
        if(keyName==='q'||keyName==='w'||keyName==='e'||
               keyName==='a'||keyName==='s'||keyName==='d'
               ||keyName==='z'||keyName==='x'||keyName==='c'
             ){
                this.clickablePlay(keyName.toUpperCase());
             }
        
     });
     
  }

 

    clickablePlay(id){
        //console.log(id);
       // console.log(this.state.displayText[id]);
        this.setState({display: this.state.displayText[id]});
        const audioId = document.getElementById(id);
       // console.log(audioId.src);
        switch(id){
            case 'Q':
                audioId.src = "https://s3.amazonaws.com/freecodecamp/drums/Heater-1.mp3";
                break;
            case 'W':
                audioId.src = "https://s3.amazonaws.com/freecodecamp/drums/Heater-2.mp3";
                break;
            case 'E':
                audioId.src = "https://s3.amazonaws.com/freecodecamp/drums/Heater-3.mp3";
                break;
            case 'A':
                audioId.src = "https://s3.amazonaws.com/freecodecamp/drums/Dsc_Oh.mp3";
                break;
            case 'S':
                audioId.src = "https://s3.amazonaws.com/freecodecamp/drums/Kick_n_Hat.mp3";
                break;
            case 'D':
                audioId.src = "https://s3.amazonaws.com/freecodecamp/drums/Bld_H1.mp3";
                break;
            case 'Z':
                audioId.src = "https://s3.amazonaws.com/freecodecamp/drums/Dry_Ohh.mp3";
                break;
            case 'X':
                audioId.src = "https://s3.amazonaws.com/freecodecamp/drums/Brk_Snr.mp3";
                break;
            case 'C':
                audioId.src = "https://s3.amazonaws.com/freecodecamp/drums/punchy_kick_1.mp3";
                break;
        }
        audioId.play();
    }

    render(){
        return (
            <div>
                <div className="header">
                    <h1>Drum Machine </h1>

                </div>
                <div  id="drum-machine">
                    <div id="display">{this.state.display}</div>
                    {this.state.drumPadId.map((pad,index) => <Drumpad key={pad}
                    pad={pad} clickablePlay={this.clickablePlay} count={index + 1} />)}
                    
                </div>
                <footer>Created By: Avinash</footer>
            </div>
        );
    }
}

export default DrumApp;


// WEBPACK FOOTER //
// ./src/DrumApp.js